import VaultMatterHeader from './vault-matter-header.tsx';

import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';

interface VaultExportConfigSkeletonProps {
  onBack: () => void;
}

export default function VaultExportConfigSkeleton({
  onBack,
}: VaultExportConfigSkeletonProps) {
  return (
    <Stack gap={3} sx={{ mt: 1 }}>
      <Stack gap={0.5}>
        <VaultMatterHeader
          matterName="Loading..."
          onBack={onBack}
          isLoading={true}
        />
      </Stack>
      <Stack direction="row" gap={4}>
        <Skeleton variant="rectangular" width={350} height={56} />
        <Skeleton variant="rectangular" width={200} height={56} />
      </Stack>
      <Stack direction="row" gap={4}>
        <Skeleton variant="rectangular" width={350} height={56} />
        <Skeleton variant="rectangular" width={400} height={56} />
      </Stack>
      <Skeleton variant="rectangular" width="100%" height={56} />
      <Divider sx={{ my: 1 }} />
      <Skeleton variant="rectangular" width={400} height={56} />
      <Skeleton variant="rectangular" width={400} height={100} />
    </Stack>
  );
}
